import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import { formatNumber } from 'utils/number';
import tradingDataStore from 'lib/stores/tradingData';
import { PreviewContainer } from 'global/TradingModal/styled';
import { expiryOptions } from 'global/Securities/constants/transactionForm';
import realTradingStore from '../store';

function ExercisePreview() {
  const { company, portfolioDetail } = tradingDataStore();
  const { shares, expiry } = realTradingStore();
  const {
    data: { symbol },
  } = company;
  const {
    data: { exercise_data },
  } = portfolioDetail;
  const { price } = exercise_data;

  return (
    <PreviewContainer direction="column" width="100%">
      <Flex justify="space-between" width="100%">
        <Text>Stock</Text>
        <Text family="bold">{symbol}</Text>
      </Flex>

      <Flex justify="space-between" width="100%">
        <Text>Expiry</Text>
        <Text>{expiryOptions[expiry]}</Text>
      </Flex>

      <Flex justify="space-between" width="100%">
        <Text>Exercise Price</Text>
        <Text>{formatNumber(price, false)}</Text>
      </Flex>

      <Flex justify="space-between" width="100%">
        <Text>Shares</Text>
        <Text>{shares}</Text>
      </Flex>

      <Flex justify="space-between" width="100%">
        <Text family="bold">Exercise Amount</Text>
        <Text family="bold">Rp {formatNumber(shares * price, false)}</Text>
      </Flex>
    </PreviewContainer>
  );
}

export default ExercisePreview;
